var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from "@tanstack/react-query";
import { callApiForUseQuery, useApiQuery } from "api/api";
import { isSpecialError } from "api/specialErrorHandler";
import * as React from "react";
import { useState } from "react";
import { Toast } from "toast";
export const ManageGroup = ({ auth, groupId }) => {
    const [emailToAdd, setEmailToAdd] = useState("");
    const { data, isLoading, error, refetch } = (useApiQuery("group", "GET", auth, { groupId }));
    const { isLoading: isAddingEmail, mutate: mutateAddEmail } = useMutation({
        mutationFn: (email) => __awaiter(void 0, void 0, void 0, function* () {
            return (callApiForUseQuery("group/add_email", "POST", auth, { groupId, email }));
        }),
        onSuccess: (response) => {
            Toast.success("Successfully added email: " + response.addedEmail);
            refetch();
            setEmailToAdd(""); // Clear the input field after adding the email.
        },
        onError: (error) => {
            Toast.error("Error adding email: " + error.error);
        }
    });
    if (error) {
        if (isSpecialError(error)) {
            // This endpoint should not have special errors.
            return React.createElement("div", null, "Unknown error.");
        }
        else {
            return React.createElement("div", null, error.error);
        }
    }
    if (isLoading || !data) {
        return React.createElement("div", null, "Loading...");
    }
    function addEmail(email) {
        console.info("Adding email", email);
        mutateAddEmail(email);
        setTimeout(refetch, 1000); // Mongo takes some time to update.
    }
    return React.createElement(React.Fragment, null,
        React.createElement("p", null,
            React.createElement("b", null, "Manage group")),
        React.createElement("p", null,
            React.createElement("div", null,
                data.emails.length,
                " emails added."),
            React.createElement("textarea", { style: { width: "100%" }, rows: 10, readOnly: true, value: data.emails.join("\n"), className: "ui-input" })),
        React.createElement("p", { className: "d-flex", style: { gap: "8px" } },
            React.createElement("input", { type: "text", value: emailToAdd, onChange: (e) => setEmailToAdd(e.target.value), onKeyUp: (e) => {
                    if (e.key === "Enter") {
                        addEmail(emailToAdd);
                    }
                }, placeholder: "Email address", className: "ui-input flex-grow-1" }),
            React.createElement("button", { onClick: () => addEmail(emailToAdd), className: "ui-button", disabled: isAddingEmail }, "Add email")));
};
